import api from './api';
import type { Company, CompanyFormData, HydraCollection } from '../types/entities';

const BASE_PATH = '/api/companies';

export const companiesApi = {
  getAll: async (): Promise<Company[]> => {
    const response = await api.get<HydraCollection<Company> | Company[]>(BASE_PATH);
    // Handle both JSON-LD (hydra) and plain JSON formats
    if (Array.isArray(response.data)) {
      return response.data;
    }
    return response.data['hydra:member'] ?? [];
  },

  getOne: async (id: number): Promise<Company> => {
    const response = await api.get<Company>(`${BASE_PATH}/${id}`);
    return response.data;
  },

  create: async (data: CompanyFormData): Promise<Company> => {
    const response = await api.post<Company>(BASE_PATH, data);
    return response.data;
  },

  update: async (id: number, data: Partial<CompanyFormData>): Promise<Company> => {
    const response = await api.patch<Company>(`${BASE_PATH}/${id}`, data, {
      headers: { 'Content-Type': 'application/merge-patch+json' },
    });
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`${BASE_PATH}/${id}`);
  },
};
